// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"66":"7570b2b7","592":"7570b2b7","663":"7570b2b7"}[chunkId] + ".chunk.css";
};